import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import {
  List,
  MenuItem,
  ListItemIcon,
  Typography,
  Collapse,
  Tooltip,
} from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useTranslate, useSidebarState } from 'react-admin';

interface Props {
  dense: boolean;
  handleToggle: () => void;
  icon: ReactElement;
  isOpen: boolean;
  name: string;
  children: ReactNode;
  depth: any;
}

const SubMenu = (props: Props) => {
  const { handleToggle, isOpen, name, icon, children, dense, depth } = props;
  // const translate = useTranslate();

  const [sidebarIsOpen] = useSidebarState();

  // paddingLeft is first MenuItem's padding value
  const header = (
    <MenuItem dense={dense} onClick={handleToggle} sx={{ paddingLeft: '25px' }}>
      <ListItemIcon sx={{ minWidth: 5 }}>
        {isOpen ? <ExpandMore /> : icon}
      </ListItemIcon>
      <Typography variant="inherit" color="textSecondary">
        {/* {translate(name)} */}
        {name}
      </Typography>
    </MenuItem>
  );

  return (
    <React.Fragment>
      {sidebarIsOpen || isOpen ? (
        header
      ) : (
        // <Tooltip title={translate(name)} placement="right">
        <Tooltip title={name} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          dense={dense}
          component="div"
          disablePadding
          className="SubMenu"
          sx={{
            '& .MuiMenuItem-root': {
              paddingLeft: theme =>
                // 基础缩进 + 层级递进
                `calc(${theme.spacing(4)} + ${theme.spacing(5 * (depth || 0))})`,
              borderLeft: '1px solid', // 左侧引导线
              borderColor: theme => theme.palette.divider,
              marginLeft: theme => theme.spacing(2), // 与父级间距
              position: 'relative',
              '&:before': { // 顶部连接线
                content: "''",
                position: 'absolute',
                left: -4,
                top: '50%',
                height: '1px',
                width: 8,
                backgroundColor: theme => theme.palette.divider
              }
            },
          }}
        >
          {children}
        </List>
      </Collapse>
    </React.Fragment>
  );
};

export default SubMenu;
